import { selectors as sessionSelectors } from '@clearscore/redux.session';
import { getPersonCookie } from '@clearscore/helpers.cookies';
import getDevice from '@clearscore/helpers.device';
import getEnv from '@clearscore/helpers.envs';

function _addDefaultProps(state, eventProps) {
    const sessionId = sessionSelectors.getSessionToken(state);

    return {
        p: getPersonCookie(),
        s: sessionId,
        device: getDevice(),
        ...eventProps,
    };
}

function _getTrackingParameterString(state, eventProps) {
    const eventProperties = _addDefaultProps(state, eventProps);
    let paramString = '/tr/t?tr=KM';

    Object.keys(eventProperties).forEach((eventPropKey) => {
        paramString += `&${eventPropKey}=${encodeURIComponent(eventProperties[eventPropKey])}`;
    });

    return paramString;
}

export default function createTrackingRedirectUrl(state, redirectProperties) {
    const { url, tracking } = redirectProperties;
    const trackingRedirectUrl = getEnv('TRACKING_REDIRECT_URL');
    const trackingParams = _getTrackingParameterString(state, tracking);
    const redir = encodeURIComponent(url);

    return `${trackingRedirectUrl}${trackingParams}&redir=${redir}`;
}
